const iconsConst = {
  darkColor: "#232127",
};

export default iconsConst;
